/* @flow */

import throttle from 'lodash/throttle';
import {
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import thunk from 'redux-thunk';
import reducer from './root-reducer';
import { loadState } from './local-storage';
import { type PreactAppStore } from './types';
import persistState from './persist-state';
import { iniciarRelogio } from '../ducks/relogio';

const configureStore = (): PreactAppStore => {
    /* eslint-disable-next-line */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const enhancer = composeEnhancers(applyMiddleware(thunk));

    const persistedState = loadState();

    const store: PreactAppStore = persistedState
        ? createStore(reducer, persistedState, enhancer)
        : createStore(reducer, enhancer);

    store.subscribe(throttle(persistState(store), 1000));

    store.dispatch(iniciarRelogio());

    return store;
};

export default configureStore;
